import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../Redux/connection/actions";
import ball from "../Assets/Vector (4).png";
import word from "../Assets/World.png";
import "./Navbar.css";
function Navbar() {

  const {isAuthenticatin} = useSelector((state)=> state.connect);

  const dispatch = useDispatch()
  const navigate = useNavigate();


  const loogout   = ()=>{
    dispatch(logout())
    navigate("/")
  }
 
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid p-0  m-0 align-itens-center">
          <Link to="/Main_page" className="navbar-brand fs-2 ps-2">
            Logo
          </Link>
          <button
            className="navbar-toggler me-2"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
            <form className="d-lg-flex justify-content-between align-items-center d-block bg_nav_open">
              <div className="me-2 mt-md-0 mt-4 mb-3 mb-md-0 pt-md-0 pt-3 me-3">
                <input
                  className="nosubmit input_search  mt-lg-0 mt-md-2 ms-2 mt-sm-2 "
                  type="search"
                  placeholder="Search..."
                />
              </div>
              <div className="mt-lg-0 mt-md-2 mt-sm-2 pt-md-0 pt-3">
                <Link
                  to="/Points_user"
                  className="fw-bold text-decoration-none text-dark me-3 "
                >
                  <span
                    data-bs-target="#navbarSupportedContent"
                    data-bs-toggle="collapse"
                  >
                    Point
                  </span>
                </Link>
              </div>
              <div className="mt-lg-0 mt-md-2 mt-sm-2 pt-md-0 pt-3 ">
                <img
                  src={ball}
                  height="20px"
                  className="me-3 mt-md-0 "
                  alt=""
                />
              </div>
              <div className="mt-lg-0 mt-md-2 mt-sm-2 pt-md-0 pt-3">
                <img
                  src={word}
                  height="20px"
                  className="me-3 mt-md-0 "
                  alt=""
                />
              </div>
              <div className="mt-lg-0 mt-md-2 mt-sm-2 pt-md-0 pt-3">
                {isAuthenticatin ?<>
                  <Link
                  to=""
                  className="text-decoration-none fw-bold text-dark me-3 mt-md-0 mt-3"
                >
                  <span
                    data-bs-target="#navbarSupportedContent"
                    data-bs-toggle="collapse"
                    onClick={()=>loogout()}
                  >
                    logout
                  </span>
                </Link></>:<>
                <Link
                  to="/"
                  className="text-decoration-none fw-bold text-dark me-3 mt-md-0 mt-3"
                >
                  <span
                    data-bs-target="#navbarSupportedContent"
                    data-bs-toggle="collapse"
                  >
                    login
                  </span>
                </Link></>
                }
               
              </div>
              <div className="mt-2 mt-lg-0 mt-md-2 pt-md-0 pt-3">
                <Link to="/Register" className="text-decoration-none">
                  <button className="btn_register  me-2 my-md-0 my-2 mb-4">
                    <span
                      data-bs-target="#navbarSupportedContent"
                      data-bs-toggle="collapse"
                    >
                      Register
                    </span>
                  </button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
